import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UuidService {
  private readonly UUID_KEY = 'fixz_app_uuid';
  private appUuid: string = '';

  constructor() {
    this.initializeUuid();
  }

  /**
   * Initialize UUID: retrieve from localStorage or generate new one
   */
  private initializeUuid(): void {
    const storedUuid = localStorage.getItem(this.UUID_KEY);
    
    if (storedUuid) {
      this.appUuid = storedUuid;
    } else {
      this.appUuid = this.generateUuid();
      localStorage.setItem(this.UUID_KEY, this.appUuid);
    }

  }

  /**
   * Generate a UUID v4
   */
  private generateUuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  /**
   * Get the app UUID
   */
  getUuid(): string {
    return this.appUuid;
  }

  /**
   * Regenerate UUID (useful for testing or explicit reset)
   */
  regenerateUuid(): string {
    this.appUuid = this.generateUuid();
    localStorage.setItem(this.UUID_KEY, this.appUuid);
    return this.appUuid;
  }
}
